var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._t("activator"),
      _vm.value
        ? _c(
            "div",
            { staticClass: "relative" },
            [
              _c(
                "PopUpContainer",
                {
                  attrs: { lightBackground: "" },
                  on: {
                    close: function ($event) {
                      return _vm.$emit("input")
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "absolute z-20 top-2 right-0 bg-white rounded-md",
                    },
                    [_vm._t("default")],
                    2
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }